import { WizardHotelPWAComponent } from "src/components/flexComponents/WizardHotelPWA/WizardHotelPWA";
import { mapTravelDate } from "./WizardStateMapper";
import { IntentMediaPropsHotels } from "src/components/utility/Ads/IntentMedia/mappers/typings";

export function mapLegacyHotelWizardState(state: WizardHotelPWAComponent): IntentMediaPropsHotels {
  return {
    page_id: "homepage.hotels",
    adults: state.totalAdults,
    children: state.totalChildren,
    travelers: state.totalTravelers,
    travel_date_end: mapTravelDate(state.travelEndDate),
    travel_date_start: mapTravelDate(state.travelStartDate),
    rooms: state.totalRooms,
    hotel_market_id: state.hotelRegionId,
    destination_city: state.cityName,
    destination_country: state.country,
    trigger_exit_unit: "Y",
  };
}
